module.exports = __webpack_public_path__ + "static/model-g-maps.72c06d7c5787032ac2f0f7879885e79b.svg";